import { render, staticRenderFns } from "./PaymentWait.vue?vue&type=template&id=32544bbc&scoped=true&"
import script from "./PaymentWait.vue?vue&type=script&lang=ts&"
export * from "./PaymentWait.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentWait.vue?vue&type=style&index=0&id=32544bbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32544bbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowLeft: require('/usr/www/nuxt/components/Icon/IconArrowLeft.vue').default})
